import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import {
  getCurrentSiteFromLocalStorage,
  getUserResources,
  USER_RESOURCES_QUERY_CONFIG,
  USER_RESOURCES_QUERY_KEY,
} from '@hotjar/user-resources';
import type { UserResources } from '@hotjar/user-resources';
import { useCurrentUser } from '@hotjar/user';

export const useUserResources = (): UseQueryResult<UserResources, Error> => {
  const { data } = useCurrentUser();

  const userId = data?.id;

  return useQuery(USER_RESOURCES_QUERY_KEY, () => getUserResources(userId as number), {
    enabled: !!userId,
    placeholderData: () => {
      const currentSite = getCurrentSiteFromLocalStorage();

      if (!currentSite) {
        return undefined;
      }

      return {
        organizations: [{ ...currentSite.organization }],
        sites: [{ ...currentSite }],
      };
    },
    ...USER_RESOURCES_QUERY_CONFIG,
  });
};
